export default __webpack_public_path__ + "static/ps2-82c317fe81a47843e86be359f465a800.jpg";